<template>
  <div class="presentation">
    <!-- DEBUT BANNIERE -->

    <div class="ban"></div>
    <div class="container">
      <div class="page">
        <!-- DEBUT FIL D'ARIANE -->

        <nav aria-label="Breadcrumb" class="breadcrumb">
          <ul>
            <li>
              <router-link to="/">ACCUEIL</router-link>
            </li>
            <li>
              <span aria-current="page" class="current-page"
                >NOS PRESTATIONS</span
              >
            </li>
          </ul>
        </nav>

        <!-- FIN FIL D'ARIANE -->
        <div class="contain_presta">
          <h1>QUELS SERVICES VOUS FAUT-IL ?</h1>
          <div class="content">
            <div class="service">
              <i class="fal fa-house-damage"></i>
              <h2>ÉLECTRICITÉ, DOMOTIQUE</h2>
              <ul>
                <li>Rénovations totales</li>
                <li>Tableaux électriques</li>
                <li>Poses d'automatismes portail</li>
                <li>Gestions de l’éclairage et de volets roulants</li>
                <li>Alarmes</li>
                <li>Chauffages électriques</li>
                <li>Mises aux normes</li>
              </ul>
              <div class="qualifications_a ">
                <a href="http://docdif.fr.grpleg.com/general/ouidoo/pdf/legrand-my-home-up-domotique.pdf" target="_blank" rel="noopener noreferrer">
                  <img src="../assets/img/Qualifications/mini_4073100852_85_partenaire-legrand-my-home_r2_c2.png" alt="Qualification Legrand My Home">
                </a>
              </div>
            </div>
            <div class="service">
              <i class="fal fa-solar-panel"></i>
              <h2>PHOTOVOLTAÏQUE</h2>
              <ul>
                <li>Études personnalisées</li>
                <li>Montages de dossiers administratifs</li>
                <li>
                  Poses de panneaux photovoltaïques en revente totale ou en
                  autoconsommation
                </li>
                <li>Changements onduleurs</li>
              </ul>
              <div class="qualifications">
                <a href="https://www.qualit-enr.org/particuliers/informer-qualif/decouvrez-qualipv" target="_blank" rel="noopener noreferrer">
                  <img src="../assets/img/Qualifications/10073_logo-QualiPV-2022-RGE.jpg" alt="Qualification QualiPV">
                </a>
                <a href="https://www.pvcycle.fr/" target="_blank" rel="noopener noreferrer">
                  <img src="../assets/img/Qualifications/PV-CYCLE.png" alt="Qualification PV Cycle">
                </a>
              </div>
            </div>
            <div class="service">
              <i class="fal fa-air-conditioner"></i>
              <h2>CHAUFFAGE, CLIMATISATION</h2>
              <ul>
                <li>Climatisations air/air split, gainables</li>
                <li>Pompes à chaleur air/eau</li>
                <li>Remplacements de chaudières</li>
                <li>Planchers chauffants eau</li>
                <li>Études</li>
                <li>Maintenances</li>
              </ul>
              <div class="qualifications">
                <a href="https://www.qualit-enr.org/particuliers/informer-qualif/decouvrez-qualipac" target="_blank" rel="noopener noreferrer">
                  <img src="../assets/img/Qualifications/10094_logo-QualiPAC-2022-RGE.jpg" alt="Qualification QualiPAC">
                </a>
              </div>
            </div>
            <div class="service">
              <i class="fal fa-outlet"></i>
              <h2>ÉLECTRICITÉ TERTIAIRE ET INDUSTRIELLE</h2>
              <ul>
                <li>Électricité bâtiments industriels</li>
                <li>Stockages agricoles</li>
                <li>Ateliers de production</li>
                <li>Bureaux, magasins</li>
                <li>Alarmes incendie</li>
                <li>Réseaux informatiques</li>
              </ul>
              <div class="qualifications">
                <a href="https://www.les-energies-renouvelables.eu/conseils/tout-savoir-sur-la-qualification-rge-reconnu-garant-environnement/quest-ce-que-le-label-rge/" target="_blank" rel="noopener noreferrer">
                  <img src="../assets/img/Qualifications/label_rge_r2_c2.png" alt="Label RGE">
                </a>
              </div>
            </div>
          </div>
          <div class="galerie">
            <h3>NOS RÉALISATIONS</h3>
            <div class="filterBtn">
              <button @click="catFilter = 'tout'">TOUS</button>
              <button @click="catFilter = 'ÉLECTRICITÉ, DOMOTIQUE'">ÉLECTRICITÉ, DOMOTIQUE</button>
              <button @click="catFilter = 'PHOTOVOLTAÏQUE'">PHOTOVOLTAÏQUE</button>
              <button @click="catFilter = 'CHAUFFAGE, CLIMATISATION'">CHAUFFAGE, CLIMATISATION</button>
              <button @click="catFilter = 'ÉLECTRICITÉ TERTIAIRE ET INDUSTRIELLE'">
                ÉLECTRICITÉ TERTIAIRE ET INDUSTRIELLE
              </button>
            </div>
            <!-- <transition name="show"> -->
            <div class="bloc-pix" v-if="filterData.length" > <!--:key="show"-->
              <div
                v-for="(realisation, index) in filterData"
                :key="index"
                class="picture"
              >
                <router-link
                  :to="{
                    name: 'realisation',
                    params: {
                      id: realisation.idA,
                      title: deleteSpace(
                        deleteParenthesis(realisation.titleA.toLowerCase())
                      )
                    }
                  }"
                >
                  <div
                    class="img"
                    :style="{
                      backgroundImage:
                        'url(https://cdn-gbbu02.graphibox.eu/pub/4/medias/achievements/' +
                        realisation.idA +
                        '/' +
                        realisation.pictureThumbA +
                        ')'
                    }"
                  >
                    <div class="galerie_over">
                      <div class="galerie-txt">
                        <p>{{ realisation.titleA.toUpperCase() }}</p>
                        <i class="fal fa-plus-circle"></i>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <div v-else>
              <h3>Aucun élément n'est présent dans cette catégorie</h3>
            </div>
            <!-- </transition> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { prestaMixin } from "../mixins/prestaMixin";
import { titleMixin } from "../mixins/titleMixin";

export default {
  metaInfo: {
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Nous proposons des services d'électricité et domotique, de photovoltaïque, de chauffage et climatisation ainsi que d'électricité tertiaire et industriel à Gimont dans le Gers"
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "Services, Électricité, Domotique, Photovoltaïque, Chauffage, Climatisation, Électricité tertiaire, Électricité industriel"
      }
    ]
  },
  name: "prestations",
  mixins: [prestaMixin, titleMixin],
  data() {
    return {
      title: "Électricien chauffagiste photovoltaïque climatisation",
      filter: "",
      catFilter: "tout",
      // show: 0
    };
  },
  beforeMount() {
    this.allCat();
  },
  computed: {
    filterData: function() {
      var dataArray;
      if(this.catFilter == "tout") {
        dataArray = this.dataArray
      } else {
        dataArray = this.dataArray.filter(
          prod => prod["categoryNameA"] == this.catFilter
        )
      }
      return  dataArray;
    }
  },
  methods: {
    allCat() {
      this.filter = this.dataArray
      return this.filter;
    },
    changeCat(categorieName) {
      return (this.filter = this.dataArray.filter(
        prod => prod["categoryNameA"] == categorieName
      ));
    },
  }
};
</script>

<style scoped>
.contain_presta {
  text-align: center;
  margin-top: 3rem;
}
.content {
  margin-top: 3rem;
  display: flex;
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 3px;
}
.service {
  width: 21%;
  text-align: center;
  padding: 1rem;
}
.service h2 {
  font-size: 1.12rem;
  padding-top: 1rem;
}
.service ul {
  margin: 0;
  text-align: left;
}
.service li {
  list-style-type: circle;
  font-size: 0.85rem;
}
.qualifications_a {
  margin-top: 20px;
}
.qualifications {
  margin-top: 30px;
}
.qualifications a {
  padding-left: 6px;
}
.qualifications_a img,
.qualifications img {
  filter: grayscale(0%);
  transition: all 0.3s ease-out;
  max-width: 100px;
}
.qualifications_a img:hover,
.qualifications img:hover {
  filter: grayscale(100%);
  transition: all 0.3s ease-out;
}
.fa-house-damage,
.fa-solar-panel,
.fa-air-conditioner,
.fa-outlet {
  font-size: 3rem;
  color: rgb(173, 17, 30);
}
.filterBtn {
  padding: 1rem 0 2rem 0;
  display: flex;
  justify-content: space-evenly;
}
.filterBtn button {
  font-family: Montserrat-SemiBold;
  color: black;
  background-color: white;
  border: 2px solid #eeeded;
  border-radius: 3px;
  padding: 12px;
  cursor: pointer;
  outline: none;
}
.filterBtn button:hover {
  background-color: black;
  color: white;
}
.galerie {
  margin-top: 6rem;
}
.bloc-pix {
  display: flex;
  flex-wrap: wrap;
  position: relative;
}
.picture {
  width: 24.5%;
  height: 250px;
  margin: 0 0.5% 0.5% 0;
  position: relative;

}
.img {
  position: relative;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.galerie_over {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: all 0.6s ease-out;
  color: white;
  background-color: rgba(0, 0, 0, 0.712);
}
.img:hover .galerie_over {
  opacity: 1;
  cursor: pointer;
  transition: all 0.6s ease-out;
}
.galerie-txt {
  width: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.fa-plus-circle {
  font-size: 2rem;
}
@media all and (max-width: 1024px) {
  .content {
    display: flex;
    flex-wrap: wrap;
  }
  .service {
    width: 45%;
  }
}
@media all and (max-width: 800px) {
  .content {
    display: flex;
    flex-wrap: wrap;
  }
  .service {
    width: 40%;
  }
  .picture {
    width: 32%;
  }
}
@media all and (max-width: 700px) {
  .filterBtn {
    display: none;
  }
}
@media all and (max-width: 600px) {
  .picture {
    height: 180px;
  }
}
@media all and (max-width: 500px) {
  .service {
    width: 100%;
  }
  .picture {
    width: 49%;
  }
}
</style>
